// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3ystj","header":"ClearentDisclaimer_header__3tarJ","inner":"ClearentDisclaimer_inner__3FDp_"};